import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/offers`;

const OfferManager = {
  // Get offer by ID
  async getOfferById(id) {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Get all offers
  async getAllOffers() {
    const response = await axios.get(BASE_URL);
    return response.data;
  },

  // Get all active offers
  async getActiveOffers() {
    const response = await axios.get(`${BASE_URL}/active`);
    return response.data;
  },

  // Create a new offer
  async createOffer(offerDTO) {
    const response = await axios.post(BASE_URL, offerDTO);
    return response.data;
  },

  // Update an existing offer
  async updateOffer(id, offerDTO) {
    const response = await axios.put(`${BASE_URL}/${id}`, offerDTO);
    return response.data;
  },

  // Delete an offer by ID
  async deleteOffer(id) {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
};

export default OfferManager;
